<template>
  <div class="container-fluid d-none d-md-block">
    <div class="row">
      <div class="col-sm-12 p-0">
        <div class="breadcrumb">
          <ul>
             
            <li> <router-link :to="{ name: 'home' }">{{ _T('Home') }}</router-link></li>
            <li><span>></span> {{_T('Order tracking')}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed:{
    ...mapGetters(['_T'])
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  background-color: $light-border;
  margin-bottom: 0;
  ul {
    li {
      span {
        color: $color-primary;
        padding-right: $px3;
      }
      + li {
        padding-left: $px5;
      }
    }
  }
  &.d-md-block {
    &.d-none {
      display: none !important;
    }
  }
}
</style>
